import React from "react";

export function VideoUploadProgress({ video }) {
  const status = video.uploadStatus || "pending";
  const progress = Number(video.uploadProgress || 0);
  const label = {
    pending: "업로드 대기",
    uploading: `업로드 중 ${progress}%`,
    completed: "업로드 완료",
    failed: "업로드 실패",
  }[status] || "업로드 대기";
  const barClass = status === "failed"
    ? "bg-red-500"
    : status === "completed"
      ? "bg-emerald-500"
      : "bg-violet-500";

  return (
    <div className="mt-1" title={video.uploadError || label}>
      <div className="h-1.5 overflow-hidden rounded-full bg-neutral-200">
        <div
          className={`h-full transition-[width] duration-200 ${barClass}`}
          style={{ width: `${status === "pending" ? 0 : Math.max(3, progress)}%` }}
        />
      </div>
      <div className={`mt-0.5 truncate text-[10px] ${status === "failed" ? "text-red-500" : "text-neutral-500"}`}>
        {label}
      </div>
    </div>
  );
}

export function FieldLabel({ children }) {
  return (
    <div className="cms-detail-field-label w-32 h-9 flex items-center px-3 bg-[#F9FAFB] text-xs text-[#8B8B8B]">
      {children}
    </div>
  );
}

export function ReadField({ children }) {
  return <div className="flex-1 h-9 flex items-center px-3 bg-white text-sm text-black">{children}</div>;
}

export function InputField({ value, onChange, type = "text", disabled = false }) {
  return (
    <div
      className={`flex-1 h-9 flex items-center border border-neutral-200 rounded-md ${
        disabled ? "cursor-not-allowed bg-neutral-100" : "bg-white"
      }`}
    >
      <input
        type={type}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder="-"
        className={`w-full h-full px-3 text-sm bg-transparent outline-none ${
          disabled ? "cursor-not-allowed text-neutral-400" : "text-black"
        }`}
      />
    </div>
  );
}

export function TextAreaField({ value, onChange, maxLength = 1000 }) {
  const length = String(value || "").length;
  return (
    <div className="flex-1 rounded-md border border-neutral-200 bg-white">
      <textarea
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        placeholder="-"
        className="min-h-[180px] w-full resize-y bg-transparent px-3 py-2 text-sm text-black outline-none"
      />
      <div className="border-t border-neutral-100 px-3 py-1 text-right text-[11px] text-neutral-400">
        {length}/{maxLength}
      </div>
    </div>
  );
}
